import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/user/user.service';
// import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

declare var $: any;

@Component({
  selector: 'app-clinician-popup',
  templateUrl: './clinician-popup.component.html',
  styleUrls: ['./clinician-popup.component.css']
})
export class ClinicianPopupComponent implements OnInit {

  @Input() public patientNote;
  isCaseManagement = false;
  constructor(public activeModal: NgbActiveModal, public userService: UserService) {
    // this.patientNote = patientNotes;
  }

  ngOnInit() {


    if (this.userService.CurrentUser) {
      if (this.userService.CurrentUser.isCaseManagement) {
        this.isCaseManagement = true;
      }


    } else {
      const userLoaded = this.userService.userInfoLoaded.subscribe(info => {
        if (this.userService.CurrentUser) {
          if (this.userService.CurrentUser.isCaseManagement) {
            this.isCaseManagement = true;
          }
          userLoaded.unsubscribe();
        }
      });
    }

    if (!this.isCaseManagement) {
      this.expandCollapse();

    } else {
      this.expandCollapse();
    }

  }

  close() {
    this.activeModal.close();
  }

  expandCollapse() {
    $(document).ready(function () {
      // Toggle plus minus icon on show hide of collapse element
      $('.collapse').on('show.bs.collapse', function () {
        $(this).prev('.card-header').find('.fa').removeClass('fa-plus').addClass('fa-minus');
      }).on('hide.bs.collapse', function () {
        $(this).prev('.card-header').find('.fa').removeClass('fa-minus').addClass('fa-plus');
      });
      // Add minus icon for collapse element which is open by default
      $('.collapse.show').each(function () {
        $(this).prev('.card-header').find('.fa').addClass('fa-minus').removeClass('fa-plus');
      });
    });
  }

}
